var map = {
	"./Game1.png": 6457,
	"./Game2.png": 8091,
	"./Game3.png": 6031,
	"./Game4.png": 3322,
	"./Game5.png": 5393,
	"./Game6.png": 7973,
	"./Game7.png": 9033,
	"./Game8.png": 889
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7324;